<template>
  <b-container>
    <div class="container-fluid">
      <b-row>
        <b-col>
          <h4 class="ml-3 mt-2">Providers</h4>
        </b-col>
      </b-row>
      <b-row class="mb-1 mr-1 ml-1">
        <b-col
          xs="12"
          sm="12"
          md="12"
          lg="4"
          xl="4"
          class="d-flex justify-content-center mt-1"
        >
        </b-col>

        <b-col xs="12" sm="12" md="12" lg="4" xl="4" class="mt-1">
          <b-input-group
            size="sm"
            class="shadows rounded-right rounded-left align-middle"
          >
            <b-form-input
              id="filterInput"
              v-model="filter"
              class="filter-input rounded-right rounded-left"
              type="search"
              @change="getData($event)"
            />
            <b-input-group-append class="rounded-right rounded-left">
              <b-icon
                icon="search"
                variant="primary"
                class="h5 m-2 align-middle"
              />
            </b-input-group-append>
          </b-input-group>
        </b-col>

        <b-col xs="12" sm="12" md="12" lg="4" xl="4" class="text-center mt-1">
          <b-button variant="success" @click="showModal()">
            <b-icon icon="plus" class="mt-1" />
          </b-button>
        </b-col>
      </b-row>
      <div class="pt-4">
        <div class="container-fluid">
          <b-table
            thead-class="text-center bg-light-grey "
            head-variant="light"
            bordered
            small
            show-empty
            outlined
            stacked="md"
            :fields="fields"
            :items="providers.data"
            id="tableMain"
            :busy="isLoadingProviders"
            class="text-break"
          >
            <template #empty>
              <div class="text-center">
                <h6>{{ $t("thereAreNoRecordsToShow") }}</h6>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner variant="primary" class="align-middle"></b-spinner>
                <p>Loading</p>
              </div>
            </template>
            <template v-slot:cell(website)="{ item }">
              <a :href="item.website" target="_blank">
                {{ item.website }}
              </a>
            </template>
            <template v-slot:cell(info)="{ item }">
              <label v-if="item.manual == 1"> Manual</label>
              <label v-else-if="item.manual == 0"> API</label>
            </template>

            <template v-slot:cell(type)="{ item }">
              <label v-if="item.wholesale == 1"> Wholesale</label>
              <label v-if="item.wholesale == 0"> Retail</label>
            </template>

            <template v-slot:cell(actions)="row">
              <div class="text-center">
                <b-form-group>
                  <b-icon
                    v-b-tooltip.hover
                    title="Details"
                    icon="eye"
                    class="h5 m-2"
                    @click="editItem(row.item)"
                  ></b-icon>
                  <b-icon
                    v-b-tooltip.hover
                    title="Delete"
                    v-if="row.field.delete"
                    :icon="row.item.status !== 1 ? 'toggle-off' : 'toggle-on'"
                    class="h5 m-2"
                    @click="
                      row.item.status !== 1
                        ? activateItem(row.item)
                        : deleteItem(row.item)
                    "
                  ></b-icon>
                </b-form-group>
              </div>
            </template>
          </b-table>

          <b-row>
            <b-col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              class="d-flex justify-content-end"
            >
              <b-pagination
                :value="providers.data ? providers.data.currentPage : 1"
                :total-rows="providers.data ? providers.data.totalRows : 0"
                :per-page="providers.perPage"
                @change="changePage($event)"
                class="mb-2"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-modal
        ref="providerModal"
        id="providerModal"
        size="lg"
        hide-footer
        body-class="pl-0 pr-0"
        ok-disabled
        @hidden="providerItem = {}"
      >
        <ProviderForm
          :providerItem="providerItem"
          :refreshData="getData"
          :hideModal="hideModal"
        />
      </b-modal>
    </div>
  </b-container>
</template>
<script>
import ProviderForm from "./ProviderForm.vue";

import { GET_PROVIDERS } from "./actions";
import { mapState } from "vuex";

import { generalMixin } from "@/modules/mixin.js";
export default {
  name: "ProviderTable",
  components: { ProviderForm },
  mixins: [generalMixin],
  computed: {
    ...mapState({
      providers: (state) => state.adminStore.providers.providers,
      isLoadingProviders: (state) =>
        state.adminStore.providers.providers.status == "fetching",
    }),
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Name", class: "text-center" },
        { key: "website", label: "Web site" },
        { key: "info", label: "Info", class: "text-center" },
        { key: "type", label: "Type", class: "text-center" },

        {
          key: "actions",
          label: "Actions",
        },
      ],

      providerItem: {},
      filter: "",
    };
  },
  methods: {
    async getData(filter = "") {
      const payload = {
        search: filter,
        status: 1,
      };
      this.$store
        .dispatch(GET_PROVIDERS, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    async deleteItem(item) {
      const confirm = await this.showConfirmDeleteBox();
      if (!confirm) return;
      const payload = {
        id: item.id,
        status: 0,
      };
      this.$store
        .dispatch("DELETE_USER_BUYER", payload)
        .then(() => {
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    async activateItem(item) {
      const payload = {
        id: item.id,
        status: 1,
      };
      this.$store
        .dispatch("PUT_USER_BUYER", payload)
        .then(() => {
          this.makeToast("Success", "Provider updated successfully", "success");
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast(this.user.error.response.data.message, {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    showModal() {
      this.$bvModal.show("providerModal");
    },
    editItem(item) {
      console.log(item);
      this.providerItem = item;
      this.$bvModal.show("providerModal");
    },
    changePage(page, filter = "") {
      const payload = {
        roleName: "ROLE_AGENT,ROLE_ADMIN",
        search: filter,
        page: page,
      };
      this.$store
        .dispatch(GET_PROVIDERS, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },

    hideModal() {
      this.$bvModal.hide("providerModal");
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
